export const taptapServiceType = {
  PARTS_OUT: 'PARTS OUT',
  FOR_BUILD: 'FOR BUILD',
  LAPTOP: 'LAPTOP',
  MONITOR: 'MONITOR',
  ADDITIONAL_PURCHASE: 'ADDITIONAL PURCHASE',
  SALES_TRANSFER: 'SALES TRANSFER',
  BUILD_SALES_TRANSFER: 'BUILD SALES TRANSFER',
  PARTS_OUT_SALES_TRANSFER: 'PARTS OUT SALES TRANSFER',

  BUILD_TRANSFER_BRANCH_RECEIVING: ' BUILD (SALES TRANSFER) BRANCH RECEIVING',

  BUILD_TRANSFER_BRANCH_DISPATCHING:
    ' BUILD (SALES TRANSFER) BRANCH DISPATCHING',

  PARTS_OUT_TRANSFER_BRANCH_RECEIVING:
    ' PARTS OUT (SALES TRANSFER) BRANCH RECEIVING',

  PARTS_OUT_TRANSFER_BRANCH_DISPATCHING:
    ' PARTS OUT (SALES TRANSFER) BRANCH DISPATCHING',

  BUILD_RMA_DIFFERENT_PC_PARTS_WT_ADD_COST:
    'BUILD RMA (DIFFERENT PC PARTS but additional cost)',

  BUILD_RMA_SAME_PC_PARTS: 'BUILD RMA (SAME PC PARTS)',

  BUILD_RMA_DIFFERENT_PC_PARTS_WT_REFUND:
    'BUILD RMA (DIFFERENT PC PARTS but refund some)'
};

export const taptapOptionsServiceType = [
  {
    key: 'parts_out',
    label: taptapServiceType.PARTS_OUT,
    value: taptapServiceType.PARTS_OUT
  },
  {
    key: 'for_build',
    label: taptapServiceType.FOR_BUILD,
    value: taptapServiceType.FOR_BUILD
  },
  {
    key: 'laptop',
    label: taptapServiceType.LAPTOP,
    value: taptapServiceType.LAPTOP
  },

  {
    key: 'monitor',
    label: taptapServiceType.MONITOR,
    value: taptapServiceType.MONITOR
  },
  {
    key: 'additional_purchase',
    label: taptapServiceType.ADDITIONAL_PURCHASE,
    value: taptapServiceType.ADDITIONAL_PURCHASE
  },
  {
    key: 'build_sales_transfer',
    label: taptapServiceType.BUILD_SALES_TRANSFER,
    value: taptapServiceType.BUILD_SALES_TRANSFER
  },
  {
    key: 'parts_out_sales_transfer',
    label: taptapServiceType.PARTS_OUT_SALES_TRANSFER,
    value: taptapServiceType.PARTS_OUT_SALES_TRANSFER
  },

  {
    key: 'build_rma_different_pc_parts_with_additional_cost',
    label: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_ADD_COST,
    value: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_ADD_COST
  },

  {
    key: 'build_rma_different_pc_parts_with_refund',
    label: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_REFUND,
    value: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_REFUND
  },

  {
    key: 'build_rma_same_pc_parts',
    label: taptapServiceType.BUILD_RMA_SAME_PC_PARTS,
    value: taptapServiceType.BUILD_RMA_SAME_PC_PARTS
  }
];
